import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b8f32fae&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f32fae')) {
      api.createRecord('b8f32fae', component.options)
    } else {
      api.reload('b8f32fae', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b8f32fae&", function () {
      api.rerender('b8f32fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dApejngTNuto/JS/imageCarousel.vue"
export default component.exports